import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
/* Components */
import Avatar from '../../../common/avatar/avatar';
import DashboardOptions from '../../dashboard-options/dashboard-options';
import TextOverflowTooltip from '../../../common/TextOverflowTooltip';
import UserCheckmark from '../../../common/user-checkmark/user-checkmark';
import IconButton from '../../../common/icon-button/icon-button';
import Checkbox from '../../../common/form-elements/checkbox/checkbox';
/* Helpers */
import {getWidgetListWithNoDuplicatesAndSorted} from '../../../../helpers/dashboard-helpers';
/* Styles */
import './dashboard-block.scss';

class DashboardBlock extends Component {
  handleOnClick = () => {
    if (!this.props.isExportMode) {
      this.props.openDashboardPage(this.props.dashboard)();
    }
  };

  render() {
    return (
      <div
        className={`glu-content glu-dashboard-block cursor-pointer${
          this.props.isHighLighted ? ' glu-dashboard--highlighted' : ''
        }`}
        onClick={this.handleOnClick}
      >
        <div className="glu-flex">
          <div className="glu-col-xs-8 glu-flex glu-flex-col">
            <div className="glu-flex glu-flex-row glu-content__section">
              {this.props.image ? <Avatar imageSrc={this.props.image} /> : null}
              <div className="glu-flex glu-flex-col glu-flex-justify-center dashboard-title-created glu-h3">
                <TextOverflowTooltip
                  title={this.props.dashboard.title}
                  renderChildren={(ref) => (
                    <div className="dashboard-title" ref={ref}>
                      {this.props.dashboard.title}
                    </div>
                  )}
                />
                <div className="dashboard-created-by">
                  {this.props.dashboard.modalFormData.selectedPermissionSettingsId === 1 && (
                    <IconButton icon="private" />
                  )}
                  <UserCheckmark
                    label="Created by: "
                    ownerId={this.props.dashboard.ownerId}
                    userLabel={this.props.dashboard.createdBy}
                  />
                </div>
                {this.props.dashboard.createdIn ? (
                  <div className="dashboard-created-in">
                    Created in: {this.props.dashboard.createdIn}
                  </div>
                ) : null}
              </div>
            </div>
            <pre className="glu-content-pre dashboard-description glu-content__section">
              {this.props.dashboard.description ? this.props.dashboard.description : ''}
            </pre>
          </div>
          <div className="glu-col-xs-8">
            <div className="glu-h4 text-bold glu-content__section">Tags</div>
            <div className="glu-content__section">{this.props.renderDashboardTags()}</div>
          </div>
          <div className="glu-col-xs-8 glu-flex glu-flex-row">
            <div className="glu-content__section">
              <div className="glu-h4 text-bold">Widget list</div>
              <div className="widget-list dashboard-description">
                {this.props.dashboard.widgetTitleList.length > 0
                  ? getWidgetListWithNoDuplicatesAndSorted(
                      this.props.dashboard.widgetTitleList
                    ).join(', ')
                  : '-'}
              </div>
            </div>
          </div>
          <div tooltip-id="dashboard-options">
            {this.props.isExportMode ? (
              <Checkbox
                className="dashboard-checkbox"
                onChange={this.props.toggleCheckedForExport}
                isChecked={this.props.isCheckedForExport}
              />
            ) : (
              <DashboardOptions
                className="dashboard-options"
                dashboard={this.props.dashboard}
                toggleDashboardModal={this.props.toggleDashboardModal}
                addDashboardToFavorite={this.props.addDashboardToFavorite}
                removeDashboardFromFavorites={this.props.removeDashboardFromFavorites}
                onClone={this.props.onClone}
                openEditPage={this.props.openEditPage}
                handleDashboardInfoClick={this.props.handleDashboardInfoClick}
                onExportDashboard={this.props.onExportDashboard}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

DashboardBlock.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired,
  renderDashboardTags: PropTypes.func.isRequired,
  toggleDashboardModal: PropTypes.func.isRequired,
  addDashboardToFavorite: PropTypes.func.isRequired,
  removeDashboardFromFavorites: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  openEditPage: PropTypes.func.isRequired,
  handleDashboardInfoClick: PropTypes.func.isRequired,
  openDashboardPage: PropTypes.func.isRequired,
  isHighLighted: PropTypes.bool.isRequired,
  image: PropTypes.string,
  isExportMode: PropTypes.bool,
};

DashboardBlock.defaultProps = {
  image: null,
  isExportMode: false,
};

function mapStateToProps(state) {
  return {
    isExportMode: state.dashboardReducer.isExportMode,
  };
}

export default connect(mapStateToProps)(DashboardBlock);
